var map = {
	"./Disabled.svg": 2411,
	"./HasWarnings.svg": 2412,
	"./Healthy.svg": 2413,
	"./Unavailable.svg": 2414,
	"./Unhealthy.svg": 2415,
	"./Unknown.svg": 2416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1185;